import { Form, Row, Col, Button } from "react-bootstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  editModal,
  openModal,
  resetFormState,
  setLoading,
  setDateValidError,
  setSelectValidError,
} from "../../slices/common/reducer";
import { AgMemberModalLayoutJSON } from "./Json/AgMemberLayoutJson";
import { renderElement } from "../../Components/Common/FormRendererV2/Renderer";
import { getOrgId } from "../../Utils/CommonUtils";
import { createAgMember } from "./AgMemberService"
import { useState } from "react";


const NewAgMemberModal = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const loading = useSelector((state) => state.common.loading);
  console.log("loading", loading);
  const formState = useSelector((state) => state.common.formRendererState);
  const agMemberFieldJson = useSelector(
    (state) => state.agMember.agMemberFieldJson
  );
  const selectedUser = useSelector((state) => state.header.selectedUser);
  // const organizationId = getOrgId();

  const handleClose = () => {
    dispatch(openModal(false));
    dispatch(editModal(false));
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
  };

  console.log(loading);
  const addNewClickHandler = (e) => {
    e.preventDefault();
     dispatch(setLoading(true));   

    if (formState) {
      dispatch(setDateValidError(false));

      if (formState.rm_id) {
        dispatch(setSelectValidError(false));
        createAgMember(formState, "AGM", selectedUser.organizationid);
      } else {
        dispatch(setSelectValidError(true));
      }
    } else {
      dispatch(setDateValidError(true));
    }
  };

  return (
    <Modal
      isOpen={modalShow}
      onHide={() => handleClose()}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <Form
        className="tablelist-form"
        onSubmit={addNewClickHandler}
      >
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          {"New Member"}
        </ModalHeader>
        <ModalBody className="modal-body">
          <Row className="g-3">
            <Col lg={12}>
              {AgMemberModalLayoutJSON.map((element) => (
                <div key={element.elementid}>
                  {element.child.map((child) =>
                    renderElement(child, agMemberFieldJson, formState)
                  )}
                </div>
              ))}
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                <Button disabled={loading}
                  type="submit"
                  className="primary primary_button"
                  id="addNewMember"
                >
                   save
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default NewAgMemberModal;
